var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: ["job-vita--section", "job-vita--grid"] }, [
    _c("div", { staticClass: "job-vita--section-title" }, [
      _c(
        "div",
        {
          class: [
            "job-vita--section-title-icon",
            { "job-vita--section-title-icon-full-match": _vm.isFullMatch }
          ]
        },
        [
          _c("Icon", {
            attrs: {
              icon: _vm.isFullMatch ? "checkmark" : "tilde",
              color: "white"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", [_vm._v(_vm._s(_vm.grid.title))])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "job-vita--grid-areas" },
      _vm._l(_vm.grid.areas, function(area) {
        return _c("Area", {
          key: area.id,
          attrs: {
            area: area,
            "job-profile-id": _vm.jobProfileId,
            "pseudonym-id": _vm.pseudonymId
          },
          on: {
            upgrade: function($event) {
              return _vm.$emit("upgrade")
            }
          }
        })
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }